module.exports = new __parcel__URL__("native-issue-table-skeleton.tpl.e6209376.svg").toString();